import React from 'react';
import PropTypes from 'prop-types';
import { FDPrimaryActionButton } from '@facet-wealth/design';

export const ZoomButton = ({ meetingResource }) => {
  const link = meetingResource.attr('link');
  const linkDisabled = link.length === 0;

  return (
    <FDPrimaryActionButton
      disabled={linkDisabled}
      href={link}
      label={linkDisabled ? 'Zoom Link Not Found' : 'Launch Zoom'}
    />
  );
};

ZoomButton.propTypes = {
  meetingResource: PropTypes.object.isRequired,
};
